import { IPoint2d } from '@/editor/math/IPoint2d';
import { globalStores } from '..';
import { getBoxOutline } from '@/editor/utils';

export function getAllFurnitureOutlines(excludeFurnitureIds?: string[]) {
  const furnitureDatas = globalStores.modelStore.getFurnitureDatas();

  const outlines: { start: IPoint2d; end: IPoint2d }[] = [];
  for (const furnitureData of furnitureDatas) {
    if (excludeFurnitureIds?.includes(furnitureData.id)) {
      continue;
    }

    const outline = getBoxOutline(furnitureData);
    outlines.push(...outline);
  }

  return outlines;
}
